import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import Spinner from 'src/components/library/spinner/Spinner';
import UnderConstruction from 'src/components/under-construction/UnderConstruction';
import { FEATURE_FLAG_KEYS } from 'src/config/featureFlags';
import { syncFeatureFlagsOperation } from 'src/store/feature-flags/feature-flags.operations';
import {
    featureFlagsReadySelector,
    isFeatureEnabledSelector,
} from 'src/store/feature-flags/feature-flags.selectors';

const LoadingShell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background-color: ${({ theme }) => theme?.background?.default || '#ffffff'};
`;

/**
 * Loads feature flags for all sessions (including anonymous) and blocks the
 * portal when `enable-under-maintenance` is enabled in LaunchDarkly.
 */
const AppMaintenanceGate = ({ children }) => {
    const dispatch = useDispatch();
    const flagsReady = useSelector(featureFlagsReadySelector);
    const flagsLoading = useSelector((state) => state.featureFlags?.loading);
    const isUnderMaintenance = useSelector((state) =>
        isFeatureEnabledSelector(state, FEATURE_FLAG_KEYS.ENABLE_UNDER_MAINTENANCE));

    useEffect(() => {
        if (!flagsReady && !flagsLoading) {
            dispatch(syncFeatureFlagsOperation());
        }
    }, [dispatch, flagsReady, flagsLoading]);

    if (!flagsReady) {
        return (
            <LoadingShell role="status" aria-live="polite" aria-label="Loading application">
                <Spinner size="large" />
            </LoadingShell>
        );
    }

    if (isUnderMaintenance) {
        return <UnderConstruction />;
    }

    return children;
};

AppMaintenanceGate.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AppMaintenanceGate;
